import React from 'react';
import { Shield, Award, CheckCircle, Users, Clock, Compass } from 'lucide-react';
export function AboutUs() {
  return <section id="about" className="py-16 bg-white" data-id="element-16">
      <div className="container mx-auto px-4" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <div className="inline-flex items-center justify-center mb-4" data-id="element-19">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ft96BQXpN2jabTTRnFyFuA/crowninspectionlogosmall.png" alt="Crown icon" className="w-10 h-10 mr-3" data-id="element-20" />
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B365D]" data-id="element-21">
              About Crown Inspection Services
            </h2>
          </div>
          <p className="text-[#2C3E50] text-lg max-w-3xl mx-auto" data-id="element-22">
            Southwest Florida's most trusted home inspection company since 2008,
            providing thorough inspections and detailed reports to protect your
            investment.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16" data-id="element-23">
          <div data-id="element-24">
            <h3 className="text-2xl font-bold text-[#1B365D] mb-4 flex items-center" data-id="element-25">
              <span data-id="element-26">Our Story</span>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ft96BQXpN2jabTTRnFyFuA/crowninspectionlogosmall.png" alt="Crown icon" className="w-6 h-6 ml-2" data-id="element-27" />
            </h3>
            <p className="text-[#2C3E50] mb-4" data-id="element-28">
              Crown Inspection Services was founded in 2008 with a simple
              mission: to provide homeowners and buyers in Southwest Florida
              with honest, thorough, and reliable inspection services.
            </p>
            <p className="text-[#2C3E50] mb-4" data-id="element-29">
              With over 15 years of experience in the construction and home
              inspection industry, our team has inspected thousands of homes
              throughout Lee, Collier, and Charlotte counties, helping
              homeowners and buyers make informed decisions about their
              investments.
            </p>
            <p className="text-[#2C3E50]" data-id="element-30">
              As a locally owned and operated business, we understand the unique
              challenges of Florida homes, from hurricane preparedness to
              moisture concerns in our humid climate. Our extensive knowledge of
              local building codes and construction practices ensures you
              receive the most relevant and valuable inspection possible.
            </p>
          </div>
          <div className="relative" data-id="element-31">
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#1B365D] rounded-lg opacity-20" data-id="element-32"></div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/g66f89sGSjcYFy9k1DqYNc/Crown_Logo.png" alt="Crown Inspection Services Logo" className="w-full h-full object-contain rounded-lg shadow-xl relative z-10" data-id="element-33" />
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-[#D4AF37] rounded-lg opacity-20" data-id="element-34"></div>
          </div>
        </div>
        <div className="bg-[#F8F9FA] rounded-xl p-8 shadow-lg mb-16" data-id="element-35">
          <div className="flex flex-col md:flex-row items-center mb-8" data-id="element-36">
            <div className="bg-[#1B365D] p-4 rounded-full mb-4 md:mb-0 md:mr-6" data-id="element-37">
              <Shield size={32} className="text-[#D4AF37]" data-id="element-38" />
            </div>
            <div data-id="element-39">
              <h3 className="text-2xl font-bold text-[#1B365D] mb-2" data-id="element-40">
                Our Mission
              </h3>
              <p className="text-[#2C3E50]" data-id="element-41">
                To provide homeowners with peace of mind through thorough
                inspections, detailed reports, and exceptional customer service,
                helping them make informed decisions about their most important
                investments.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-42">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-43">
              <Award className="text-[#D4AF37] mb-3" size={28} data-id="element-44" />
              <h4 className="font-bold text-[#1B365D] text-lg mb-2" data-id="element-45">
                Licensed & Insured
              </h4>
              <p className="text-[#2C3E50] text-sm" data-id="element-46">
                Our inspectors hold multiple professional licenses and
                certifications, ensuring the highest standards of inspection
                quality.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-47">
              <Clock className="text-[#D4AF37] mb-3" size={28} data-id="element-48" />
              <h4 className="font-bold text-[#1B365D] text-lg mb-2" data-id="element-49">
                15+ Years Experience
              </h4>
              <p className="text-[#2C3E50] text-sm" data-id="element-50">
                With over 15 years in the industry, we've seen it all and know
                exactly what to look for in Florida homes.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-51">
              <Users className="text-[#D4AF37] mb-3" size={28} data-id="element-52" />
              <h4 className="font-bold text-[#1B365D] text-lg mb-2" data-id="element-53">
                Customer Focused
              </h4>
              <p className="text-[#2C3E50] text-sm" data-id="element-54">
                We prioritize clear communication, prompt service, and thorough
                explanations to ensure you understand your inspection results.
              </p>
            </div>
          </div>
        </div>
        <div className="mb-8" data-id="element-55">
          <h3 className="text-2xl font-bold text-[#1B365D] mb-6 text-center" data-id="element-56">
            Why Choose Crown Inspection Services?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-57">
            <div className="flex items-start" data-id="element-58">
              <div className="bg-[#F8F9FA] p-2 rounded-full mr-4 flex-shrink-0" data-id="element-59">
                <CheckCircle size={24} className="text-[#0077BE]" data-id="element-60" />
              </div>
              <div data-id="element-61">
                <h4 className="font-bold text-[#1B365D] text-lg mb-1" data-id="element-62">
                  Same-Day Reports
                </h4>
                <p className="text-[#2C3E50]" data-id="element-63">
                  We deliver comprehensive inspection reports on the same day as
                  your inspection, allowing you to make timely decisions.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-64">
              <div className="bg-[#F8F9FA] p-2 rounded-full mr-4 flex-shrink-0" data-id="element-65">
                <CheckCircle size={24} className="text-[#0077BE]" data-id="element-66" />
              </div>
              <div data-id="element-67">
                <h4 className="font-bold text-[#1B365D] text-lg mb-1" data-id="element-68">
                  Thorough Inspections
                </h4>
                <p className="text-[#2C3E50]" data-id="element-69">
                  Our detailed inspections cover all major systems and
                  components of your home, providing a comprehensive evaluation.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-70">
              <div className="bg-[#F8F9FA] p-2 rounded-full mr-4 flex-shrink-0" data-id="element-71">
                <CheckCircle size={24} className="text-[#0077BE]" data-id="element-72" />
              </div>
              <div data-id="element-73">
                <h4 className="font-bold text-[#1B365D] text-lg mb-1" data-id="element-74">
                  Local Expertise
                </h4>
                <p className="text-[#2C3E50]" data-id="element-75">
                  As Southwest Florida residents, we understand the unique
                  challenges of homes in our region, from hurricane preparedness
                  to moisture issues.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-76">
              <div className="bg-[#F8F9FA] p-2 rounded-full mr-4 flex-shrink-0" data-id="element-77">
                <CheckCircle size={24} className="text-[#0077BE]" data-id="element-78" />
              </div>
              <div data-id="element-79">
                <h4 className="font-bold text-[#1B365D] text-lg mb-1" data-id="element-80">
                  Insurance Expertise
                </h4>
                <p className="text-[#2C3E50]" data-id="element-81">
                  We specialize in wind mitigation and 4-point inspections that
                  can help you qualify for significant insurance discounts.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-82">
          <a href="tel:2396997080" className="inline-flex items-center justify-center bg-[#1B365D] hover:bg-[#14294A] text-white py-3 px-8 rounded-lg font-bold transition-colors duration-200 shadow-lg" data-id="element-83">
            <Compass size={20} className="mr-2 text-[#D4AF37]" data-id="element-84" />
            Start Your Inspection Journey Today
          </a>
        </div>
      </div>
    </section>;
}